module.exports = __webpack_public_path__ + "img/ep-H-dosis.5701dff5.jpg";